import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check, Clock, AlertTriangle, Users } from "lucide-react";
import { PlanDef } from "./plans-data";

interface Props {
  currentSub: any;
  isTrial: boolean;
  daysRemaining: number | null;
  plans: PlanDef[];
}

const SubscriptionStatus = ({ currentSub, isTrial, daysRemaining, plans }: Props) => {
  if (!currentSub) return null;

  const isPerChild = currentSub.pricing_model === "per_child";

  const borderClass = isTrial
    ? "border-blue-500/50 bg-blue-50/30 dark:bg-blue-950/10"
    : currentSub.status === "expired"
      ? "border-destructive/50 bg-destructive/5"
      : "border-green-500/50 bg-green-50/30 dark:bg-green-950/10";

  return (
    <Card className={borderClass}>
      <CardContent className="p-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {isTrial ? (
              <Clock className="w-6 h-6 text-blue-600" />
            ) : currentSub.status === "active" ? (
              <Check className="w-6 h-6 text-green-600" />
            ) : (
              <AlertTriangle className="w-6 h-6 text-destructive" />
            )}
            <div>
              <p className="font-bold text-lg">
                {isTrial
                  ? "فترة تجربة مجانية"
                  : isPerChild
                    ? "اشتراك بالطفل 👶"
                    : `الخطة الحالية: ${plans.find((p) => p.id === currentSub.plan)?.name || currentSub.plan}`}
              </p>
              <p className="text-sm text-muted-foreground">
                {isTrial
                  ? `تنتهي التجربة خلال ${daysRemaining} ${daysRemaining === 1 ? "يوم" : "أيام"}`
                  : currentSub.status === "active"
                    ? daysRemaining !== null
                      ? `ينتهي خلال ${daysRemaining} يوم - ${currentSub.billing_cycle === "yearly" ? "سنوي" : "شهري"}`
                      : `اشتراك ${currentSub.billing_cycle === "yearly" ? "سنوي" : "شهري"} نشط`
                    : "اشتراكك منتهي - يرجى التجديد"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isPerChild && (
              <Badge variant="outline" className="flex items-center gap-1 text-sm px-3 py-1">
                <Users className="w-3 h-3" />
                {currentSub.children_count_snapshot ?? "—"} طفل × {currentSub.price_per_child} ج.م
              </Badge>
            )}
            {daysRemaining !== null && daysRemaining <= 7 && (
              <Badge variant="destructive" className="text-sm px-3 py-1">
                {daysRemaining === 0 ? "ينتهي اليوم!" : `باقي ${daysRemaining} يوم`}
              </Badge>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionStatus;
